export default __webpack_public_path__ + "static/prince-00f9c79e9ab66fe8077465b9f2172dd5.png";